<template lang="pug">
  .positions-table
    v-data-table(
      class="pt-4",
      :headers="headers",
      :items="positionsList",
      :loading="loading",
      no-data-text="Нет должностей для указанного подразделения",
      hide-actions)
      template(slot="items" slot-scope="props")
        td {{ props.index + 1 }}
        td {{ props.item.position }}
        // td
          a(@click="editPosition(props.item.id, props.item)") Редактировать
        td
          a(@click="submitDeletePosition(props.item.id, props.item.position)", class="red--text") Удалить
    DeleteDialog(
      :show="show",
      dispatchType="position",
      @close-dialog="closeDeleteDialog",
      @delete-position="deletePosition")
      div(slot="title") Вы действительно хотите удалить,<br><b>{{ positionName }}</b>?
</template>

<script>
import axios from 'axios'
import DeleteDialog from '../../../Common/DeleteDialog/DeleteDialog'
export default {
  name: 'PositionsItemTable',
  components: { DeleteDialog },
  props: {
    divisionId: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    headers: [
      { text: '№', value: 'id', sortable: false },
      { text: 'Название', value: 'position' },
      // { text: 'Действие', value: 'action1', sortable: false, align: 'left' },
      { text: 'Действие', value: 'action', sortable: false, align: 'left' }
    ],
    positionsList: [],
    loading: false,
    show: false,
    positionId: '',
    positionName: ''
  }),
  mounted() {
    this.getPositionList()
  },
  methods: {
    getPositionList() {
      axios({
        method: 'GET',
        url: '/api/Position/list/',
        params: { divisionId: this.divisionId }
      }).then(response => {
        this.positionsList = response.data.result
      }).catch(error => {
        console.log(error.response.data)
      })
    },
    submitDeletePosition(id, position) {
      this.positionId = id
      this.positionName = position
      this.show = true
    },
    closeDeleteDialog() {
      this.positionId = ''
      this.positionName = ''
      this.show = false
    },
    deletePosition() {
      axios({
        method: 'DELETE',
        url: '/api/Position/delete',
        data: { divisionId: this.divisionId, positionId: this.positionId }
      }).then(response => {
        this.show = false
        this.getPositionList()
      }).catch(error => {
        console.log(error)
      })
    }
    // editPosition(id, item) {
    //   this.$router.push({ path: `/main/organisation/division/position/edit/${id}` })
    //   this.$store.commit('SAVE_POSITION_ITEM', item)
    // }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/OrganisationStructure/Position/PositionItemTable/PositionItemTable.vue